import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class ComponentsConfig extends BasicConfig {
  privileges: {
    assigned: {
      // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: string;
      jobs: string;
    };
    associate: {
      candidate_to_job: string;
      jobs_to_candidate: string;
    };
    job: {
      view: string;
      create: string;
      edit: string;
      notes: string;
      files: string;
      publish: string;
    };
    candidates: {
      edit: string;
      notes: string;
      resumes: string;
      files: string;
      filesReadOnly: string;
    };
  };
}

export type ComponentsPrivileges = ComponentsConfig['privileges'];
